export function addCurrent(config) {
    return {
        type: 'ADD_CURRENT',
        config,
    }
}

export function updatedConfigCalleds(enabletagsoncalleds, enableautomaticcalledtagging, applyinternalexpirationvalidation) {
  console.log("entrei aqui 1")
  return {
      type: 'UPDATE_CONFIG_CALLEDS',
      enabletagsoncalleds,
      enableautomaticcalledtagging,
      applyinternalexpirationvalidation
  }
}


export function updatedConfigArticles(enabletagsonarticles) {
  
  return {
      type: 'UPDATE_CONFIG_ARTICLES',
      enabletagsonarticles
  }
}


export function updatedConfigUsers(enabletagsonusers) {
  
  return {
      type: 'UPDATE_CONFIG_USERS',
      enabletagsonusers
  }
}
